export const CART_TYPE = "modal" || "drawer";

export const ANIMATION_LOAD = "true" === "true";
export const ANIMATION_INTERVAL =
  "interval" === "default" ? 0 : 0.05;
// fade_up, fade_down, fade_in
export const ANIMATION_INTERVAL_STYLE =
  "fade_up" || "fade_up";
